import { gql } from '@apollo/client'

export const CategoriesQuery = gql`
    query categoriesQuery($firmId: String!) {
        categories(firmId: $firmId) @client
    }
`

export const CategoriesQueryByFamily = gql`
    query getCategories(
        $firmId: String
        $masterId: String
        $sectionNumber: String
        $sectionName: String
    ) {
        productFamily(
            firmId: $firmId
            masterId: $masterId
            id: $sectionNumber
            name: $sectionName
        ) {
            id
            productFamilyCategories {
                name
            }
        }
    }
`

export const ProprietaryCategoriesByFamily = gql`
    query getProprietaryCategoriesByFamily(
        $input: GetProprietaryCategoriesByFamilyInput!
    ) {
        getProprietaryCategoriesByFamily(input: $input) {
            name
        }
    }
`
